<template>
  <div>
    <div class="home-feature">
      <div class="hf-foreground-container">
        <div class="hf-name">THOMAS<br/>HUNTER</div>
        <div class="hf-title">Software<br/>Engineer</div>
      </div>
      <img
          alt="Feature image, picture of stairs"
          src="/static/img/home-feature-1600w.jpg"
          class="hf-bg"
          srcset="/static/img/home-feature-1600w.jpg 1600w, /static/img/home-feature-960w.jpg 960w, /static/img/home-feature-450w.jpg 450w"/>
    </div>
    <div class="content">
      <h1>Featured Projects</h1>
      <ProjectsFeatured :size="2"></ProjectsFeatured>
      <router-link to="/projects" class="float-right more-link">More &raquo;</router-link>

      <h1>About Me</h1>
      <!-- TODO change the about me section -->
      <p>
        My name is Thomas Hunter, I have recently graduated De Montfort University with a frist class degree in Computer Science.
      </p>
      <!-- <p>
        have been programing for about 11 years, starting off with simple websites, later progressing onto other
        languages.
      </p>
      <p>
        Some languages and libraries I have used in the past include... JavaScript, jQuery, PHP, Laravel, Java, Android,
        C.
      </p>
      <p>
        Currently I&apos;m a third year student at De Montfort University studying Computer Science. With hobbies in
        amateur photography &amp; electronics.
      </p> -->
    </div>
  </div>
</template>
<script>
  import Animation from '../class/Animation';
  import ProjectsFeatured from '@/components/ProjectsFeatured.vue';
  import { easeOutCubic } from '../class/Animation/EasingFunctions';
  /**
   * Animations which are used, and need to be detached on destroy.
   * @type {Animation.ManagedAnimation[]}
   */
  let animations = [];
  export default {
    name: 'Home',
    title() {
      return 'Home';
    },
    components: { ProjectsFeatured },
    mounted() {
      let elHfName = document.querySelector('.home-feature .hf-name');

      let timer = new Animation.Timer.ScrollTimer(false, 0, () => { return elHfName.offsetTop; });
      let animation = new Animation.Animation(timer, easeOutCubic);
      animations.push(animation);

      animation.setAnimationCallback((percent, data) => {
        let cp = 'inset(0 0 0 ' + percent * 100 + '%)';
        // Support Safari browsers
        elHfName.style.webkitClipPath = cp;
        elHfName.style.clipPath = cp;
        elHfName.style.marginLeft = '-' + percent * elHfName.offsetWidth + 'px';
      });
    },
    beforeDestroy() {
      // Detach any animations attached in the view.
      animations.forEach((animation) => { animation.destroy(); });
    }
  };
</script>


<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Work+Sans:100|Yantramanav:900');
  @import "../assets/scss/variables";
  .home-feature {
    position: relative;
    height: calc(100vh - #{$headerHeight}); // Set to 100% of the viewport, subtract the title.
    overflow: hidden;

    .hf-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: 50% 40%;
    }

    .hf-foreground-container {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;

      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
    }

    .hf-name, .hf-title {
      padding: 20px;
    }

    .hf-name {
      font-size: 20pt;
      line-height: 1;
      text-align: right;

      border-right: 2px solid white;

      font-family: 'Yantramanav',serif;
    }
    .hf-title {
      font-size: 15pt;

      font-family: 'Work Sans',serif;
    }

    @media screen and (min-width: 400px){
      .hf-name {
        font-size: 25pt;
      }
      .hf-title {
        font-size: 19pt;
      }
    }

    @media screen and (min-width: 700px){
      .hf-name {
        font-size: 50pt;
      }
      .hf-title {
        font-size: 37pt;
      }
    }

    @media screen and (min-width: 1000px){
      .hf-name {
        font-size: 100pt;
      }
      .hf-title {
        font-size: 75pt;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Home.vue